import app from 'flarum/forum/app';

app.initializers.add('mattoid/flarum-ext-money-history-auto', () => {
  console.log('[mattoid/flarum-ext-money-history-auto] Hello, forum!');
});
